/* eslint-disable max-lines */
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { SearchPanel } from 'src/components/SearchPanel/SearchPanel';
import { SettingsPageStore } from 'src/stores/SettingsStores/SettingsPageStore/SettingsPageStore';
import styled from 'styled-components';

const store = SettingsPageStore;

export const SettingsPageHeaderPanel = observer(() => {
    const { t } = useTranslation();

    return (
        <StyledHeaderWrapper>
            <SearchPanel
                store={store}
                placeholder={t('Page.Settings.Filter.Search.Placeholder')}
            />
        </StyledHeaderWrapper>
    );
});

const StyledHeaderWrapper = styled.header`
    position: relative;
    display: grid;
    grid-template-columns: 1fr auto;
`;
